import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RestaurantServiceData } from '@timechef/features/restaurants/state/restaurants.models';
// import { AccountRepository } from '@timechef/features/account/state';

@UntilDestroy()
@Component({
  selector: 'app-service-selection-modal',
  templateUrl: './service-selection-modal.component.html',
  styleUrls: ['./service-selection-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServiceSelectionModalComponent implements OnInit {
  @Input() services!: RestaurantServiceData[];
  @Input() isOrderDailyLimitReached = false;

  freeServices: RestaurantServiceData[] = [];
  takenServices: RestaurantServiceData[] = [];

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    this.freeServices = this.services.filter((x) => x.existingOrderId === null);
    this.takenServices = this.services.filter((x) => x.existingOrderId !== null);
  }

  async selectService(service: RestaurantServiceData) {
    await this.modalCtrl.dismiss(service);
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }

  trackById = (_idx: any, item: { id: any }) => item.id;
  trackByLabel = (_idx: any, item: { label: any }) => item.label;
}
